// src/composables/useSiteWideHub.ts
import type { HubConnection } from "@microsoft/signalr";
import { hubManager } from "~/utils/hubManager";

export function useOrgWideHub() {
  let hub: HubConnection | null = null;

  const ensure = async () => {
    hub ??= await hubManager.getHub("orgwide", "/orgwide");
    return hub;
  };

  const on = async <T>(event: string, handler: (p: T) => void) => {
    const h = await ensure();
    h?.on(event, handler);
  };

  const off = (event: string, handler: (...args: any[]) => void) =>
    hub?.off(event, handler);

  const invoke = async (method: string, ...args: any[]) =>
    (await ensure())?.invoke(method, ...args);

  return { ensure, on, off, invoke };
}
